import { render, staticRenderFns } from "./ModalEditShobe.vue?vue&type=template&id=aaa35c82&scoped=true&"
import script from "./ModalEditShobe.vue?vue&type=script&lang=js&"
export * from "./ModalEditShobe.vue?vue&type=script&lang=js&"
import style0 from "./ModalEditShobe.vue?vue&type=style&index=0&id=aaa35c82&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aaa35c82",
  null
  
)

export default component.exports